/*
 * @描述:
 * @作者: lidong
 * @时间: Do not edit
 * @最后更新时间: Do not edit
 * @更新: lidong
 * @参考:
 */
import { handleActions } from 'redux-actions';
import { initState } from '../../../../redux/models';
import * as actionType from './actionType';

export default handleActions(
  {
    //更新信息
    [actionType.SCOPE_UPDATE]: (state, { data }) => {
      const newState = { ...state, ...data };
      return newState;
    },
    [actionType.SCOPE_FILE]: state => {
      const newState = { ...state, modalTuttonLoading: false, tableLoading: false };
      return newState;
    },
  },
  initState,
);
